import dayjs from 'dayjs'

export const formatXTick = (tick: string, index: number, length: number) => {
  const isFirst = index === 0
  const isLast = index === length - 1
  const isHalf = index === Math.floor(length / 2)
  const day = dayjs(tick)
  const labels = [day.format('MMM')]

  if (isFirst || isLast || isHalf) {
    labels.push(day.format('YYYY'))
  }

  return labels
}
